import { Link } from '@/i18n/routing';
import { useTranslations } from 'next-intl';
import { useSuspenseQuery } from '@apollo/client';
import { LocationListingGroupsQuery } from '@/query';
import { getListingLocaleSlug } from '@/utils';

export const LocationListingGroups = ({
  locale,
  page,
  slug,
  currentPage,
  setCurrentPage,
}) => {
  const t = useTranslations();

  const { data, error, networkStatus } = useSuspenseQuery(
    LocationListingGroupsQuery,
    {
      variables: {
        filter: { listingSlug: slug },
        locale,
        page,
      },
      errorPolicy: 'all',
    }
  );

  const list = data?.listingGroups?.collection || [];
  const totalPages = data?.listingGroups?.metadata?.totalPages;

  return networkStatus === 1 || error ? null : (
    <>
      {list.map((item, i) => (
        <div key={i} className="flex flex-col gap-1 min-w-0">
          <Link
            href={`/destinations/${getListingLocaleSlug(item, locale)}`}
            className="text-primary-700 text-lg font-normal underline truncate"
          >
            {item.name}
          </Link>
        </div>
      ))}
      {totalPages > currentPage && (
        <div className="flex flex-col gap-1 min-w-0">
          <a
            onClick={() => setCurrentPage(totalPages)}
            className="text-slate-500 text-lg font-normal underline inline-flex items-start leading-[normal] cursor-pointer"
          >
            {t('destinations.list.more')}{' '}
            <i className="icon-down_light text-[24px]" />
          </a>
        </div>
      )}
    </>
  );
};
